import React from 'react'
import { MarginBox, colors, LayoutBand, useTheme, useContainerWidth, Row } from '@fs/zion-ui'
import { flavors } from '../config'

export default function FormContainer({ children, flavor }) {
  const atWidth = useContainerWidth()
  const theme = useTheme()
  const backgroundColor = theme === 'day' && flavor === 'charcoal' ? colors.gray02 : flavors[flavor].solid

  return (
    <Row alignX="center">
      <LayoutBand
        style={{
          backgroundColor,
          borderRadius: atWidth({ default: 16, lg: 32 }),
          // so that the background isn't flush with the edge of the screen on mobile
          marginInline: 0,

          // handle the max width of InputBase from zion-ui; the t-shirt sizes didn't have a size that matched
          maxWidth: 'calc(82ch + calc(var(--bleedable-sides) * 2))',
        }}
        marginY="xl"
      >
        {/* Because this is a nested layoutband, we need to force margin on the x instead of letting the layoutband do it */}
        <MarginBox marginX="sm">{children}</MarginBox>
      </LayoutBand>
    </Row>
  )
}
